import EfVideo from '@elem/ui/ef-video';
import { useEffect, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const IconRePlay = (props: any) => {
    return (
        <div {...props}>
            <span>Replay</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                    d="M10.1588 10.6681C9.27999 11.5469 8.06593 12.0904 6.7249 12.0904C4.04288 12.0904 1.86865 9.91621 1.86865 7.23418C1.86865 4.55215 4.04288 2.37793 6.7249 2.37793C8.06593 2.37793 9.27999 2.92148 10.1588 3.8003C10.6061 4.24761 11.5812 5.34564 11.5812 5.34564"
                    stroke="#999999"
                    strokeWidth="0.925"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.5814 2.91748V5.34561H9.15332" stroke="#999999" strokeWidth="0.925" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
};

export default function TheComp() {
    const { isPC, isDesktop, isPad, isH5 } = useMediaDevice();
    const { t } = useLang('Oasis.SmartInsights');
    const [startPlay, setStartPlay] = useState(false);

    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');

    const videos = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1735633368781/SmartInsights-1.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1735788893348/smart_insight.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1735789040206/smart_insight_M.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1735633379708/SmartInsights-1-h5.mp4',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1735633368781/SmartInsights-1.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1735788893348/smart_insight.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1735789040206/smart_insight_M.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1735633379708/SmartInsights-1-h5.mp4',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744264254591/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343545978/AI-EU-PC.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343546294/phone_AI-EU.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744257182389/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744265151459/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.mp4',
            posterPC:
                'https://websiteoss.ecoflow.com/upload/image/1744343710229/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.jpg',
            posterH5:
                'https://websiteoss.ecoflow.com/upload/image/1744343709891/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744265151208/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E8%8B%B1%E9%95%91.mp4',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744265055501/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343687146/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU0.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343665463/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU0.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744265055284/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744265120006/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343495331/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343495245/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744265119806/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU.mp4',
        },
        // 以下素材暂未提供，先用eu的
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744264254591/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343545978/AI-EU-PC.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343546294/phone_AI-EU.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744257182389/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744264254591/%E5%BC%80%E5%8F%91-AI-%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1744343545978/AI-EU-PC.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744343546294/phone_AI-EU.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744257182389/%E5%BC%80%E5%8F%91_phone_AI_%E8%83%BD%E6%BA%90%E5%88%86%E6%9E%90-EU-%E6%AC%A7%E5%85%83.mp4',
        },
    };
    const imgItems = {
        us: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439413/SmartInsights2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615542243/SmartInsights2-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439760/SmartInsights3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439243/SmartInsights3-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439049/SmartInsights4.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439596/SmartInsights4-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615528124/SmartInsights5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439948/SmartInsights5-h5.jpg',
            ],
        ],
        ca: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439413/SmartInsights2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615542243/SmartInsights2-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439760/SmartInsights3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439243/SmartInsights3-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439049/SmartInsights4.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439596/SmartInsights4-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615528124/SmartInsights5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439948/SmartInsights5-h5.jpg',
            ],
        ],
        eu: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459319657/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456780/Frame%201612690133.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459319969/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456989/Frame%201612690134.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459320278/Frame%201612690129.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456395/Frame%201612690131.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459320539/Frame%201612690130.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456582/Frame%201612690132.png',
            ],
        ],
        uk: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459515949/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459566461/Frame%201612690153.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459516126/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459566653/Frame%201612690154.png',
            ],
            ['https://websiteoss.ecoflow.com/upload/image/1744618093425/pc.png', 'https://websiteoss.ecoflow.com/upload/image/1744618093271/m.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459516549/Frame%201612690149.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459566271/Frame%201612690147.png',
            ],
        ],

        de: [
            ['https://websiteoss.ecoflow.com/upload/image/1744617791306/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744617791120/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744618353559/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-PC.png',
                'https://websiteoss.ecoflow.com/upload/image/1744618353320/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-M.png',
            ],
            ['https://websiteoss.ecoflow.com/upload/image/1744619894167/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744619893923/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744359030813/Frame%201612690050.png',
                'https://websiteoss.ecoflow.com/upload/image/1744359096824/Frame%201612690006.png',
            ],
        ],
        fr: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744364579053/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
                'https://websiteoss.ecoflow.com/upload/image/1744364650109/Frame%201612690117.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744618440500/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-PC.png',
                'https://websiteoss.ecoflow.com/upload/image/1744618440767/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9-M.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744364579402/Frame%201612690106.png',
                'https://websiteoss.ecoflow.com/upload/image/1744364649736/Frame%201612690104.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744364579595/Frame%201612690107.png',
                'https://websiteoss.ecoflow.com/upload/image/1744364650288/Frame%201612690105.png',
            ],
        ],
        it: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459319657/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456780/Frame%201612690133.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459319969/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456989/Frame%201612690134.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459320278/Frame%201612690129.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456395/Frame%201612690131.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459320539/Frame%201612690130.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456582/Frame%201612690132.png',
            ],
        ],
        es: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459319657/%E7%94%B5%E4%BB%B7%E5%A5%97%E9%A4%90.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456780/Frame%201612690133.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459319969/%E8%8A%82%E7%9C%81%E7%94%B5%E8%B4%B9.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456989/Frame%201612690134.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459320278/Frame%201612690129.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456395/Frame%201612690131.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744459320539/Frame%201612690130.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459456582/Frame%201612690132.png',
            ],
        ],
    };
    const list = [
        {
            title: t('card1.title'),
            type: 'video',
            // pc: 'https://websiteoss.ecoflow.com/upload/video/1735633368781/SmartInsights-1.mp4',
            // posterPC: 'https://websiteoss.ecoflow.com/upload/image/1735788893348/smart_insight.jpg',
            // posterH5: 'https://websiteoss.ecoflow.com/upload/image/1735789040206/smart_insight_M.jpg',
            // h5: 'https://websiteoss.ecoflow.com/upload/video/1735633379708/SmartInsights-1-h5.mp4',
            ...videos[locale],
        },
        {
            title: t('card2.title'),
            pc: imgItems[locale][0][0],
            h5: imgItems[locale][0][1],
        },
        {
            title: t('card3.title'),
            pc: imgItems[locale][1][0],
            h5: imgItems[locale][1][1],
        },
        {
            title: t('card4.title'),
            desc: t.rich('card4.desc', {
                h: (v: string) => <span className="highlight">{v}</span>,
            }),
            pc: imgItems[locale][2][0],
            h5: imgItems[locale][2][1],
        },
        {
            title: t('card5.title'),
            desc: t.rich('card5.desc', {
                h: (v: string) => <span className="highlight">{v}</span>,
            }),
            pc: imgItems[locale][3][0],
            h5: imgItems[locale][3][1],
        },
    ];
    const [loaderVideo, setLoaderVideo] = useState(false);

    // 动画
    useEffect(() => {
        // pad 和 h5 不执行动画
        if (isPad || isH5) return;
        const box = document.querySelector('#SmartInsights') as HTMLDivElement;
        const cards = [...(document.querySelectorAll('.smart-insights-card') as never as HTMLDivElement[])];
        const cardTop = [cards[0], cards[1], cards[2]];
        const cardBottom = [cards[3], cards[4]];

        const screen = AniContainer.create({
            triggerElement: '#SmartInsights',
            triggerHook: 1,
            offset: 0,
            duration: box.offsetHeight + window.innerHeight,
            asyncFromTo: [
                [`#SmartInsights`, { opacity: 1 }, { opacity: 1 }, 0.001],
                [`#SmartInsights .smart-insights-card.card-1`, { opacity: 1 }, { opacity: 0 }, 0.1],
                [`#SmartInsights .smart-insights-card.card-2`, { opacity: 1 }, { opacity: 0 }, 0.1],
                [`#SmartInsights .smart-insights-card.card-3`, { opacity: 1 }, { opacity: 0 }, 0.1],
                [`#SmartInsights .smart-insights-card.card-4`, { opacity: 1 }, { opacity: 0 }, 0.1],
                [`#SmartInsights .smart-insights-card.card-5`, { opacity: 1 }, { opacity: 0 }, 0.1],
            ],
            asyncTimeLine: [0, 0.2, 0.2, 0.2, 0.3, 0.3],
            onProcess: (process: number) => {
                // 卡片渐入动画
                if (process >= 0.2) {
                    cardTop.forEach((card, idx) => {
                        setTimeout(() => {
                            card.classList.add('enter');
                        }, idx * 140);
                    });
                }
                if (process >= 0.4) {
                    cardTop.forEach((card) => {
                        card.classList.add('enter-after');
                    });
                    cardBottom.forEach((card, idx) => {
                        setTimeout(() => {
                            card.classList.add('enter');
                        }, idx * 140);
                    });
                }
                if (process >= 0.6) {
                    cardBottom.forEach((card) => {
                        card.classList.add('enter-after');
                    });
                }
            },
        });

        return () => {
            screen.destroy();
        };
    }, [isPC, isDesktop, isPad, isH5]);

    // 进入模块视频播放
    useEffect(() => {
        const callback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setStartPlay(true);
                }
            });
        };
        const play = new IntersectionObserver(callback, {
            threshold: 0.1,
        });
        play.observe(document.querySelector('#SmartInsights') as HTMLDivElement);

        return () => {
            play.disconnect();
        };
    }, []);

    // 懒加载视频资源
    useEffect(() => {
        const loader = AniContainer.create({
            triggerElement: IS_NA_SITES ? '#Brands' : '#ListA',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setLoaderVideo(true);
            },
        });
        return () => {
            loader.destroy();
        };
    }, []);

    return (
        <div className={`${styles.TheComp}`} id="SmartInsights">
            <div className="smart-insights-content">
                <div className="smart-insights-title">{t('title')}</div>
                <div className="smart-insights-cards">
                    {list.map((i, idx) => (
                        <div className={`smart-insights-card card-${idx + 1}`} key={idx}>
                            <div className="smart-insights-card-info">
                                <div className="smart-insights-card-title">{i.title}</div>
                                {i.desc && <div className="smart-insights-card-desc">{i.desc}</div>}
                            </div>

                            {i.type === 'video' ? (
                                loaderVideo &&
                                (isPC || isDesktop ? (
                                    <EfVideo
                                        className="SmartInsights-video"
                                        startPlay={startPlay}
                                        poster={i.posterPC}
                                        pc={i.pc}
                                        Icon={IconRePlay}
                                        preload="none"
                                    />
                                ) : (
                                    <EfVideo
                                        className="SmartInsights-video"
                                        startPlay={startPlay}
                                        pc={i.h5}
                                        poster={i.posterH5}
                                        Icon={IconRePlay}
                                        preload="none"
                                    />
                                ))
                            ) : (
                                <EfImg className="SmartInsights-img" pc={i.pc as string} h5={i.h5} />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
